<div class="login-modal-container">
  <!-- Mobile Number Entry State -->
  <div *ngIf="!sendOtp">
    <div class="modal-header-premium">
      <h3 class="modal-title">
        <i class="fa fa-sign-in"></i> Login or Register
      </h3>
      <i (click)="close(false)" class="fa fa-times close-btn" title="Close"></i>
    </div>

    <div class="modal-body-premium container-fluid">
      <div class="text-center mb-4">
        <h4 class="mb-1" style="font-weight: 600; font-family: 'Inter', sans-serif;">Welcome Back</h4>
        <p class="text-muted" style="font-size: 0.9rem;">Enter your mobile number to continue</p>
      </div>

      <div class="mb-4">
        <label class="form-label">Mobile Number</label>
        <div class="input-group" style="border: 1px solid rgba(0,0,0,0.1); border-radius: 10px; overflow: hidden; background: #f9fafb;">
          <span class="input-group-text" style="background: transparent; border: none; color: #1f2937; font-weight: 500;">+91</span>
          <input type="text" class="form-control" style="border: none !important; background: transparent;" placeholder="10-digit number" [(ngModel)]="mobile" maxlength="10" (keypress)="numberOnly($event)">
        </div>
      </div>

      <div class="text-center mt-2 mb-2">
        <button class="premium-btn" (click)="userValidate()" [disabled]="!mobile || mobile.length !== 10">Send OTP</button>
      </div>

      <div class="register-link">
        Not Registered yet? <span>Join Free</span>
      </div>
    </div>
  </div>

  <!-- OTP Verification State -->
  <div *ngIf="sendOtp">
    <div class="modal-header-premium">
      <h3 class="modal-title">
        <i class="fa fa-shield"></i> Security Verification
      </h3>
      <i (click)="close(false)" class="fa fa-times close-btn" title="Close"></i>
    </div>

    <div class="modal-body-premium container-fluid">
      <div class="otp-wrapper">
        <h4 class="otp-title">Enter Verification Code</h4>
        <p class="otp-subtitle">We've sent a 4-digit code to <span class="highlight-number">{{mobile}}</span></p>
      </div>

      <div class="otp-inputs-grid">
        <input *ngFor="let digit of otp; let i = index" 
               type="text" 
               maxlength="1" 
               class="otp-box"
               [(ngModel)]="otps[i]" 
               (input)="onInput($event, i)" 
               (keydown)="onKeyDown($event, i)"
               [ngModelOptions]="{standalone: true}" 
               (keypress)="numberOnly($event)" />
      </div>

      <div class="resend-text mb-4">
        <span>Didn't receive the code?</span>
        <span *ngIf="resendOtpTime !== '00:00'" class="text-muted">Wait {{resendOtpTime}}</span>
        <span *ngIf="resendOtpTime === '00:00'" class="resend-link" (click)="resendOTP()">Resend Now</span>
      </div>

      <div class="text-center">
        <button class="premium-btn" (click)="saveUser()">Verify & Login</button>
      </div>

      <div class="mt-3">
        <span class="skip-link" (click)="close(false)">Skip for now <i class="fa fa-angle-right"></i></span>
      </div>
    </div>
  </div>
</div>